import {
  getEducationArchiveCatList,
  getEducationCatList,
  getEducationCategoryList,
  getEducationDetail,
  getEducationList,
  getQuessAnswer,
  getStartEducation,
  getStartEducationArchive,
  pathFinishEducation,
} from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import { educationActions } from "../reducers/education";
import { t } from "i18next";
import { toast } from "react-toastify";

export const fetchEducationList = (id_eductaion = 0) => {
  return (dispatch) => {
    return apiService
      .get(getEducationList(id_eductaion))
      .then((response) => {
        dispatch(educationActions.fetchEducationList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchEducationCatList = (id_eductaion = 0) => {
  return (dispatch) => {
    return apiService
      .get(getEducationCatList(id_eductaion))
      .then((response) => {
        dispatch(educationActions.fetchEducationList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchEducationArchiveCatList = (id_eductaion = 0) => {
  return (dispatch) => {
    return apiService
      .get(getEducationArchiveCatList(id_eductaion))
      .then((response) => {
        dispatch(educationActions.fetchEducationList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchEducationCategoryList = () => {
  return (dispatch) => {
    return apiService
      .get(getEducationCategoryList())
      .then((response) => {
        dispatch(educationActions.fetchEducationCategoryList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchEducationDetail = (id_eductaion) => {
  return (dispatch) => {
    return apiService
      .get(getEducationDetail(id_eductaion))
      .then((response) => {
        dispatch(educationActions.fetchEducationDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchEducationStart = (id_eductaion, navigate, video) => {
  return (dispatch) => {
    return apiService
      .get(getStartEducation(id_eductaion))
      .then((response) => {
        dispatch(educationActions.fetchEducationStart(response.data));
        dispatch(educationActions.fetchEducationVideo(video));
        if (response?.data?.lessons?.length > 0) {
          navigate("/video-education");
        } else {
          response?.data?.question?.length > 0
            ? navigate("/video-education")
            : toast.error(t("education.errorMessage"), { theme: "colored" });
        }
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchEducationArchiveStart = (id_eductaion, navigate, video) => {
  return (dispatch) => {
    return apiService
      .get(getStartEducationArchive(id_eductaion))
      .then((response) => {
        dispatch(educationActions.fetchEducationArchiveStart(response.data));
        dispatch(educationActions.fetchEducationVideo(video));
        navigate("/video-education-archive");
      })
      .catch((err) => {
        navigate("/education-list");
        handleError(err);
      });
  };
};

//zavrsavanje edukacije
export const fetchFinishEducation = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .put(pathFinishEducation(data))
      .then((response) => {
        // navigate("/education-list");
      })
      .catch((err) => {
        navigate("/education-list");
        handleError(err);
      });
  };
};

//provera tacnog odogovra
export const fetchCheckAnswer = (questionId, guessAnswerId) => {
  return (dispatch) => {
    return apiService
      .get(getQuessAnswer(questionId, guessAnswerId))
      .then((response) => {
        // Vraćamo odgovor kako bi komponenta mogla da ga koristi
        return response.data;
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

const handleError = (err) => {
  let errorMessage = err.response ? err.response.data.message : err;
  if (!err.response) {
    toast.error(t("security.error.refresh"), { theme: "colored" });
  }
  toast.error(errorMessage, { theme: "colored" });
};
